module.exports = __webpack_public_path__ + "static/media/venetian.bf31d9ab.mtl";